// removed by extract-text-webpack-plugin
module.exports = {"pageHeader":"_3_TV-5cu5VWnaJ0vjdK0DY","noBottom":"Wu123T09V7bOeou2VNNrP","noMarginBottom":"_15oSliBZc1qptndko3-ke2","button":"_3IhHBHwdKVTN3iMfiMHAvd","reveal":"_35zNr_Wx8dGKIqAEi_eWBQ","insideReveal":"_2yGB5umsApb4Gyi2r0hMfk","cardHeader":"_1zBfx7Km3W2G1qwcJRX-JE","icon":"_36wAJJf_vToWjUgOsg7NUM","refresh-btn":"_2pEllAphJxB2g7RrdEmD9L","refresh-spin":"_3pWJQTR3NT-o8eNfvYAvaX","modal":"_2I_OTub0wELIi6P-BFS_ZC","card-header":"_3JtI1ov43VftK-MtUAdSqE","headerWrapper":"_3JaxDdqpOt_6BZBmpIqMuk"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/EmailApp/style.scss
// module id = 2551
// module chunks = 1